import { AutogenModelOrderhistProfile, AutogenRowOrderhistProfile } from "./autogen/AutogenModelOrderhistProfile";

export class ModelOrderhistProfile extends AutogenModelOrderhistProfile<RowOrderhistProfile> {
    constructor() {
        super(RowOrderhistProfile);
    }
}

export class RowOrderhistProfile extends AutogenRowOrderhistProfile {
}